import { FC, Suspense, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "./store"
import Loader from "@/components/Loader"
import { AUTO_REFRESH_INTERVAL_MS } from "@/constants/globals"
import AppRoutes from "@/routes/AppRoutes"
import { getUser } from "@/store/userSlice"

const App: FC = () => {
   const dispatch = useDispatch<AppDispatch>()
   const { isAuthenticated } = useSelector(
      ({ authReducer }: RootState) => authReducer
   )

   useEffect(() => {
      async function getUserData() {
         if (isAuthenticated) {
            try {
               await dispatch(getUser()).unwrap()
            } catch (error) {
               console.error("Fetching user data failed:", error)
            }
         }
      }
      getUserData()
   }, [dispatch, isAuthenticated])

   useEffect(() => {
      const refreshTimeout = setTimeout(() => {
         window.location.reload()
      }, AUTO_REFRESH_INTERVAL_MS)

      return () => clearTimeout(refreshTimeout)
   }, [])

   return (
      <Suspense fallback={<Loader />}>
         <AppRoutes />
      </Suspense>
   )
}

export default App
